import { render } from "./outsourcePerson.vue?vue&type=template&id=39424acc&scoped=true"
import script from "./outsourcePerson.vue?vue&type=script&lang=js"
export * from "./outsourcePerson.vue?vue&type=script&lang=js"

import "./outsourcePerson.vue?vue&type=style&index=0&id=39424acc&lang=less&scoped=true"
import "./outsourcePerson.vue?vue&type=style&index=1&id=39424acc&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39424acc"]])

export default __exports__